module.exports = __webpack_public_path__ + "img/qr-code.cc818f64.svg";